import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ActiveAttributeRendererWrapper } from '../-components';
import { SectionWrapper, prefetchActiveCatalog } from '../-shared';
import type { DeviceCatalogSection } from '../-shared/-query';

export const Route = createFileRoute(
  '/_staff/device-catalog/active/$id/_layout/profile/',
)({
  component: ActiveProfile,
  loader: prefetchActiveCatalog,
});

function ActiveProfile() {
  const renderAttributes = useCallback(
    (section: DeviceCatalogSection) => (
      <ActiveAttributeRendererWrapper
        attributes={section.attributes}
        sectionKey={String(section.sectionKey)}
      />
    ),
    [],
  );

  return <SectionWrapper renderAttributes={renderAttributes} />;
}
